<template>
    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-2 pl-0">
            <div class="vx-card p-6 mt-2">
                <div class="component">
                    <span class="text-title-shades">
                    {{ $t("title.gender") }}
                    <div v-if="!showGender" class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    </span>
                </div>
                <div class="component">
                    <span class="text-time-title">
                        {{ countDays }} {{ $t("day")}}
                        <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                        </span>
                    </span>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full mt-6 md:w-1/3 sm:flex hidden">
                        <img src="@/assets/images/chart-svg/male.svg" alt="" width="180" height="305">
                    </div>
                    <div class="vx-col w-full mt-6 md:w-1/3">
                        <div class="vx-row container-gender">
                            <div class="md:w-1/2 pl-2 pr-2 mt-2 gender-reposive">
                                <div class="chart-male" :style="{height: percentMale}">
                                    <div class="component text-center" style="margin-top:-30px">
                                        <span class="font-medium">{{ percentMale }}</span>
                                    </div>
                                    <div class="component text-center mt-2 text-white">
                                        <span class="font-medium" style="font-size:12px">{{ gender.totalMale }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="md:w-1/2 pr-2 pl-2 mt-2">
                                <div class="chart-female" :style="{height: percentFemale}">
                                    <div class="component text-center" style="margin-top:-30px">
                                        <span class="font-medium">{{ percentFemale }}</span>
                                    </div>
                                    <div class="component text-center mt-2 text-white">
                                        <span class="font-medium" style="font-size:12px">{{ gender.totalFemale }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-6 md:w-1/3 sm:flex hidden">
                        <img src="@/assets/images/chart-svg/female.svg" alt="" width="180" height="305">
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 pl-0">
            <div class="vx-card p-6 mt-2">
                <div class="component">
                    <span class="text-title-shades">
                    {{ $t("title.ages") }}
                    <div v-if="!showAge" class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    </span>
                </div>
                <div class="component">
                    <span class="text-time-title">
                        {{ countDays }} {{ $t("day")}}
                        <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                        </span>
                    </span>
                </div>
                <div class="w-full flex container-age mt-4 border-female">
                    <div class="vx-col w-full mt-2 md:w-1/6 sm:flex hidden">
                        <img class="mt-4" src="@/assets/images/chart-svg/female.svg" alt="" width="90" height="133">
                    </div>
                    <div class="md:w-1/6 pl-2 pr-2 mt-2 response-male" v-for="(age, indexAge) in percentDataFemale" :key="indexAge">
                        <div class="chart-female-age" :style="{height: age.percent}">
                            <div class="component text-center" style="margin-top:-30px">
                                <span class="font-medium" style="color: #ffaeaf">{{age.percent}}</span>
                            </div>
                            <div class="component text-center text-white mt-2">
                                <span class="font-medium" style="font-size:12px">{{ age.age }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex w-full">
                    <div class="vx-col w-full mt-2 md:w-1/6 text-center sm:flex hidden">
                    </div>
                    <div class="vx-col w-full mt-3 md:w-1/6 text-center" v-for="(ageRange, indexAge) in dataAgeRange" :key="indexAge">
                        <span class="font-bold">{{ ageRange }}</span>
                    </div>
                </div>
                <div class="w-full flex container-age mb-4 border-male mt-2">
                    <div class="vx-col w-full mt-2 md:w-1/6 sm:flex hidden">
                        <img style="margin-top: -30px" src="@/assets/images/chart-svg/male.svg" alt="" width="90" height="133">
                    </div>
                    <div class="md:w-1/6 pl-2 pr-2 mt-2 response-male" v-for="(age, indexAge) in percentDataMale" :key="indexAge">
                        <div class="age-chart" :style="{height: age.percent}">
                            <div class="component w-full text-center age-chart-position">
                                <span class="font-medium" style="color: #2f80ec">{{ age.percent }}</span>
                            </div>
                            <div class="component text-center text-white">
                                <span class="font-medium" style="font-size:12px">{{ age.age }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        dateRange: {
            type: Object
        },
        topicId: null,
        topicGroupId: null,
        refreshData: {default: 0}
    },
    watch: {
        refreshData: function (newVal, oldVal) {
            this.initScreen();
        }
    },
    data(){
        return {
            countDays: 0,
            dataAgeRange: ['-18', '18-25', '26-40', '41-55', '55+'],
            optionalAge: {
                countAgeByMale: [
                    {age: 20},
                    {age: 30},
                    {age: 40},
                    {age: 50},
                    {age: 60},
                ],
                countAgeByFemale: [
                    {age: 20},
                    {age: 30},
                    {age: 40},
                    {age: 50},
                    {age: 60},
                ]
            },
            percentDataMale: [],
            percentDataFemale: [],
            percentMale: null,
            percentFemale: null,

            showGender: false,
            showAge: false,
            gender: {},
            ages: {}

        }
    },
    methods: {
        countDateRange: function(fromDate, toDate) {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const firstDate = new Date(fromDate);
            const secondDate = new Date(toDate);
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            this.countDays = diffDays;
        },
        countAgeRange: function(condition){
            this.showAge = false;
            this.$processor.post('/user-data/age-range', condition).then((res) => {
                let totalMale = 0;
                this.optionalAge.countAgeByMale.map(el => {
                    totalMale = totalMale + el.age;
                    return el;
                })
                let totalFemale = 0;
                this.optionalAge.countAgeByFemale.map(el => {
                    totalFemale = totalFemale + el.age;
                    return el;
                })
                let index = 0;
                this.optionalAge.countAgeByMale.map(el => {
                    let percent = ((el.age/totalMale) * 100).toFixed(0) + "%";
                    let result = {
                        age: el.age,
                        percent: percent
                    }
                    this.percentDataMale[index] = result;
                    index++;
                    return el;
                })
                let indexFemale = 0;
                this.optionalAge.countAgeByFemale.map(el => {
                    let percent = ((el.age/totalFemale) * 100).toFixed(0) + "%";
                    let result = {
                        age: el.age,
                        percent: percent
                    }
                    this.percentDataFemale[indexFemale] = result;
                    indexFemale++;
                    return el;
                })
                this.showAge = true;
            })
        },
        getCountGender: function(condition){ 
            this.showGender = false;
            this.$processor.post('/user-data/count-gender', condition).then((res) => {
                let result = res.data;
                this.gender = result;
                let total = (result.totalMale + result.totalFemale);
                this.percentMale = ((result.totalMale/total) * 100).toFixed(0) + "%";
                this.percentFemale = ((result.totalFemale/total) * 100).toFixed(0) + "%";
                this.showGender = true;
            })
            
        },
        initScreen(){
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));

            const condition = {
                from: this.dateRange.startDate,
                to: this.dateRange.endDate,
                topicId: this.topicId,
                groupId: this.topicGroupId,
                topics: []
            }
            this.getCountGender(condition);
            this.countAgeRange(condition);
           
            this.countDateRange(this.dateRange.startDate, this.dateRange.endDate);
            this.tooltipMouseHover();
        }
    },
    async created(){
        this.initScreen();
    }
}
</script>

<style scoped>
.chart-male {
    background:#2f80ec; 
    padding-top:-20px;
    height:230px;
    position: absolute; 
    bottom: 0; 
    width:70px
}
.chart-female-age {
    background:#ffaeaf; 
    padding-top:-20px;
    height:230px;
    position: absolute; 
    bottom: 0; 
    width:70px
}
@media screen and (max-width: 400px){
    .response-male {
        margin-right: 45px;
        margin-left: 2px;
    }
    .chart-female-age {
        background:#ffaeaf; 
        padding-top:-20px;
        height:230px;
        position: absolute; 
        bottom: 0; 
        width:50px
    }
    .age-chart {
        background:#2f80ec; 
        padding-top:-20px;
        height:230px;
        position: absolute; 
        top: 0; 
        width:50px !important
    }
    .gender-reposive {
        margin-right: 60px;
    }
}

.chart-female {
    background:#ffaeaf;
    padding-top:-20px;
    height:230px;
    position: absolute; 
    bottom: 0; 
    width:70px
}

.container-gender {
    position: relative; 
    height: 230px;
}
.container-age {
    position: relative; 
    height: 130px;
}
.age-chart {
    background:#2f80ec; 
    padding-top:-20px;
    height:230px;
    position: absolute; 
    top: 0; 
    width:70px
}
.age-chart-position {
    position: absolute;
    bottom: -30px;
}
.border-female {
    border-bottom: 1px solid #ffaeaf;
}
.border-male {
    border-top: 1px solid #2f80ec;
}
.text-time-title {
  font-size: 12px;
  color: #B9B9C3;
}
.text-title-shades {
    font-size: 18px;
    font-weight: bold;
    color: #5E5873;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -0.24s;
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.12s;
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px;
  }

  50%,
  100% {
    top: 16px;
    height: 4px;
  }
}
</style>